// Tiny reactive store for the global navigation guard. Pages register an
// "unsaved work" state here (via useUnsavedChanges) and the global
// <NavigationGuard /> intercepts sidebar/menu clicks and the browser back
// button to warn the user before they lose work.

let _dirty = false;
let _message = 'You may lose your work if you leave this page.';
const subs = new Set();

export function setNavGuard(dirty, message) {
  _dirty = !!dirty;
  if (message) _message = message;
  subs.forEach((fn) => { try { fn(); } catch { /* noop */ } });
}

export function getNavGuard() {
  return { dirty: _dirty, message: _message };
}

export function subscribeNavGuard(fn) {
  subs.add(fn);
  return () => subs.delete(fn);
}
